/**
 * Últimos cálculos do anônimo em localStorage (TASK-04).
 * Persiste entre sessões no mesmo browser — a conta sincroniza entre dispositivos.
 */

export interface RecentCalcEntry {
  id: string
  source: string
  title: string
  summary: string
  at: number
}

const KEY = 'calculamei:recent_calcs'
const MAX = 3

export function pushRecentCalc(entry: Omit<RecentCalcEntry, 'id' | 'at'>) {
  try {
    const prev = listRecentCalcs()
    // Uma entrada por calculadora — refazer o cálculo atualiza a existente.
    const next: RecentCalcEntry[] = [
      { ...entry, id: crypto.randomUUID(), at: Date.now() },
      ...prev.filter((p) => p.source !== entry.source),
    ].slice(0, MAX)
    localStorage.setItem(KEY, JSON.stringify(next))
  } catch {
    // private mode / quota
  }
}

export function listRecentCalcs(): RecentCalcEntry[] {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw) as RecentCalcEntry[]
    return Array.isArray(parsed) ? parsed.slice(0, MAX) : []
  } catch {
    return []
  }
}
